<div class="modal-content text-primary border-0">
  <div class="col-12 px-0">
    <owl-carousel-o [options]="customOptions" #owlCar>
      <ng-container *ngFor="let child of children">
        <ng-template carouselSlide [id]="child.MemberId">
          <div class="full-container">
            <div class="barcode-section bg-white">
              <div class="qr-info">
                <div><span class="d-none material-symbols-outlined text-grey"> close </span></div>
                <div>
                  <h5 class="mb-1 font-heading font-size-20">{{ child.Firstname }} {{ child.Lastname }}</h5>
                  <div *ngIf="card$ | async as memberCard">
                    <span class="font-size-12">{{ memberCard.ProductCode }} </span>
                  </div>
                </div>
                <div><span class="close-btn material-symbols-outlined text-grey" (click)="closeModal()"> close </span></div>
              </div>
              <div class="qr bg-white">
                <qrcode [qrdata]="child.CardBarcode" [width]="256" [errorCorrectionLevel]="'M'" [elementType]="true"> </qrcode>
              </div>
            </div>
            <div class="barcode-details bg-primary">
              <div class="barcode-info">
                <div class="text-white">
                  <label class="mb-1">{{ 'member.card.dob' | translate }}</label>
                  <div class="font-size-14">{{ child.DateOfBirth | date }}</div>
                </div>
                <div>
                  <img
                    class="logo"
                    [width]="70"
                    [height]="70"
                    [src]="'images/fortress-logo-mobile.png' | contentAssetImage"
                    draggable="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</div>
